var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vip" }, [
    _c("div", { staticClass: "vipbox-main" }, [
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "title" }, [_vm._v("VIP等级")]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.lastViplevel, function (i) {
            return _c("div", { key: i, staticClass: "item" }, [
              _c(
                "div",
                {
                  staticClass: "vipLevel-item flex flex-center-1",
                  class: { "vipLevel-light": _vm.user.vipLevel >= i },
                },
                [
                  _c("img", {
                    staticClass: "userAavatar-item",
                    attrs: { src: _vm.userAavatar, alt: "" },
                  }),
                  _c("img", {
                    staticClass: "userVipIconUrl-item",
                    attrs: { src: _vm.userVipIconUrl(i), alt: "" },
                  }),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "title" }, [_vm._v("累计金额")]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.lastViplevel, function (i) {
            return _c("div", { key: i, staticClass: "item" }, [
              _c("div", {
                staticClass: "slider",
                class: { active: _vm.user.vipLevel >= i },
              }),
            ])
          }),
          0
        ),
      ]),
      _vm.user.nickname
        ? _c("div", { staticClass: "line" }, [
            _c("div", { staticClass: "title" }, [_vm._v("/")]),
            _c("div", { staticClass: "content" }, [
              _vm.user.vipLevel < _vm.lastViplevel
                ? _c(
                    "div",
                    { staticClass: "recharge-desc flex flex-ver" },
                    [
                      _vm._v(" 当前已充值: "),
                      _c("c-vip-price", {
                        attrs: { price: _vm.user.totalRecharge || 0.0 },
                      }),
                      _vm._v(" 距离下一个等级还剩 "),
                      _c("c-vip-price", { attrs: { price: _vm.nextNeed } }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "recharge-desc flex flex-ver" },
                    [
                      _vm._v(" 当前已充值: "),
                      _c("c-vip-price", {
                        attrs: { price: _vm.user.totalRecharge || 0.0 },
                      }),
                      _vm._v(" 等级已达到最高 "),
                    ],
                    1
                  ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "title" }, [_vm._v("充值金额")]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.lastViplevel, function (i) {
            return _c(
              "div",
              { key: i, staticClass: "item" },
              [
                _c("c-vip-price", {
                  attrs: { stringValue: _vm.vipCondition[i - 1] },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "title" }, [_vm._v("每周奖励")]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.lastViplevel, function (i) {
            return _c(
              "div",
              {
                key: i,
                staticClass: "item",
                staticStyle: { "font-size": "12px" },
              },
              [
                _c("c-vip-price", { attrs: { price: _vm.vipAddOn[i - 1] } }),
                _c(
                  "div",
                  {
                    staticClass: "btn-receive",
                    class: { active: _vm.user.vipLevel == i },
                    on: {
                      click: function ($event) {
                        return _vm.GotoRecvWeekly(i)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.user.vipLevel == i ? "前往领取" : "资格不符"
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "title" }, [_vm._v("升级红包")]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.lastViplevel, function (i) {
            return _c(
              "div",
              {
                key: i,
                staticClass: "item",
                staticStyle: { "font-size": "12px" },
              },
              [
                _c("c-vip-price", {
                  attrs: { stringValue: _vm.vipGift[i - 1] },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "title" }, [_vm._v("专属红包")]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.lastViplevel, function (i) {
            return _c("div", { key: i, staticClass: "item" }, [
              _c(
                "span",
                {
                  staticClass: "btn-receive",
                  class: { active: _vm.user.vipLevel >= i },
                  on: {
                    click: function ($event) {
                      return _vm.GotoReceive(i)
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.user.vipLevel >= i ? "前往领取" : "继续努力")
                  ),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }